export class JwtDecoded {
	/**
	 * Issued at time of JWT token
	 */
	iat!: Date | string;

	/**
	 * Expiration time of JWT token
	 */
	exp!: number;

	/**
	 * Id of the user
	 */
	sub!: number;

	/**
	 * Id of the user
	 */
	unique_name!: string;

	/**
	 * Not valid before
	 */
	nbf!: number;

	/**
	 * Issuer (who created and signed this token)
	 */
	iss!: string;

	/**
	 * Audience (who or what the token is intended for)
	 */
	aud!: string;

	roleId!: string | number;
	companyId!: string;
}
